import { render, staticRenderFns } from "./journal_slide.vue?vue&type=template&id=60aebe43"
import script from "./journal_slide.vue?vue&type=script&lang=js"
export * from "./journal_slide.vue?vue&type=script&lang=js"
import style0 from "./journal_slide.vue?vue&type=style&index=0&id=60aebe43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports